import React, {useState, forwardRef, useImperativeHandle, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Modal, Divider, Image, Row, Col, Avatar, Tag} from 'antd';
import _ from 'lodash';
import ReactPlayer from 'react-player';
import styles from './moment.modal.module.less';
import {getFileUrl} from '@/page/util/appUrlUtils';
import {getTasks, likesAndComments} from '@/api/customer';

const MomentModal = forwardRef(({momentInfo}, ref) => {
    useImperativeHandle(ref, () => ({
        open,
    }));
    useEffect(() => {
        !_.isEmpty(momentInfo) && init();
    }, [momentInfo]);
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState({
        comments: 0,
        likes: 0,
    });

    const [tasks, setTasks] = useState([]);

    function init() {
        likesAndComments({
            momentId: momentInfo.momentId,
            userId: momentInfo.sysUser.extId,
        }).then(res => {
            setData(res.data);
        });
        momentInfo.createType === 0 &&
            getTasks(momentInfo.momentId).then(res => {
                setTasks(res.data);
            });
    }

    function handleCancel() {
        setVisible(false);
    }

    function open() {
        setVisible(true);
    }

    function renderTitle() {
        return (
            <div className={styles.header}>
                <p>{!_.isEmpty(momentInfo) && momentInfo.sysUser.name + '发布的朋友圈'}</p>
                <div>
                    <span className={styles.label}>点赞数：</span>
                    <span className={styles.value}>{data.likes}</span>
                    <Divider type="vertical" className={styles.divider} />
                    <span className={styles.label}>评论数：</span>
                    <span className={styles.value}>{data.comments}</span>
                </div>
            </div>
        );
    }

    function renderContentText() {
        return (
            <div className={styles.contentHeader}>
                <p className={styles.label}>文字内容</p>
                <p className={styles.value}>{momentInfo.content || '暂无文字内容'}</p>
                <Divider />
            </div>
        );
    }

    function renderContentHead() {
        return (
            <div className={styles.contentHeader}>
                <p className={styles.label}>链接名称</p>
                <p className={styles.value}>{momentInfo.linkTitle || '暂无链接名称'}</p>
                <p className={styles.label}>链接地址</p>
                <p className={styles.value}>
                    <a href={momentInfo.linkUrl || ''} target="_blank">
                        {momentInfo.linkUrl || '暂无链接地址'}
                    </a>
                </p>
                <Divider />
            </div>
        );
    }

    function renderTask() {
        return (
            <>
                <div className={styles.task}>
                    <p className={styles.label}>任务人</p>
                    {tasks.length > 0 &&
                        tasks.map((task, key) => (
                            <div key={key} className={styles.block}>
                                <Avatar src={task.sysUser.avatar} />
                                <span className={styles.name}>
                                    {task.sysUser.name}({task.sysUser.extId})
                                </span>
                                <Tag>{task.publishStatus === 0 ? '未发表' : '已发表'}</Tag>
                            </div>
                        ))}
                </div>
                <Divider />
            </>
        );
    }

    function renderMedia() {
        console.log('momentInfo', momentInfo);
        const {sysAttaches} = momentInfo;
        if (!_.isEmpty(sysAttaches)) {
            if (sysAttaches[0].contentType === 'image/jpeg') {
                return (
                    <div className={styles.media}>
                        <p className={styles.label}>图片</p>
                        <Row gutter={10}>
                            <Image.PreviewGroup>
                                {sysAttaches.map((sysAttache, key) => (
                                    <Col span={4} className={styles.img}>
                                        <Image
                                            mode="widthFix"
                                            src={getFileUrl(sysAttache.id, sysAttache.fileExt)}
                                            key={key}
                                        />
                                    </Col>
                                ))}
                            </Image.PreviewGroup>
                        </Row>
                        <Divider />
                    </div>
                );
            } else {
                const videoUrl = getFileUrl(sysAttaches[0].id, sysAttaches[0].fileExt);
                return (
                    <div className={styles.media}>
                        <p className={styles.label}>视频</p>
                        <ReactPlayer controls playing={false} url={videoUrl} />
                        <Divider />
                    </div>
                );
            }
        } else {
            return '';
        }
    }

    return (
        <Modal
            width={'70%'}
            title={renderTitle()}
            visible={visible}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose={true}
        >
            {!_.isEmpty(momentInfo) && momentInfo.createType === 0 && renderTask()}
            {!_.isEmpty(momentInfo) && renderContentText()}
            {!_.isEmpty(momentInfo) && renderContentHead()}
            {!_.isEmpty(momentInfo) && renderMedia()}
        </Modal>
    );
});

MomentModal.displayName = 'MomentModal';

MomentModal.propTypes = {
    momentInfo: PropTypes.object,
};

export default MomentModal;
